import { FC } from 'react';

import { AccessDisabled } from '../AccessDisabled/AccessDisabled';
import { BackgroundImage } from './Components/BackgroundImage/BackgroundImage';
import { WrapperContent } from './Components/WrapperContent/WrapperContent';

export const CallInvitationLinkAccessDisabledPage: FC = () => {
  return (
    <>
      <BackgroundImage />
      <WrapperContent>
        <AccessDisabled />
      </WrapperContent>
    </>
  );
};
